<template>
    <div class="page-container">
        <div class="page-top">
            <div class="total">
                <div class="total-box">
                    <div class="total-num">
                        <span>{{pageData.allowanceAmount}}</span>
                        <span class="see-bill" @click="jumpBill">
                            <span>查看津贴账单</span>
                            <van-icon name="arrow" size="16" color="#3088F5" />
                        </span>
                    </div>
                    <div class="total-text">可使用津贴(元)</div>
                </div>
            </div>
            <div class="detail">
                <div class="detail-item">
                    <div class="item-num">{{pageData.allowanceTransfer + pageData.allowanceWithdraw}}</div>
                    <div class="item-text">已使用津贴(元)</div>
                </div>
                <div class="detail-item">
                    <div class="item-num">{{pageData.allowanceTotal}}</div>
                    <div class="item-text">累计已获津贴(元)</div>
                </div>
            </div>
        </div>
        <div class="page-bottom">
            <div class="bottom-item" @click="jumpApply">
                <img src="../../assets/icon-tx.png" alt="">
                <div class="text">我要提现</div>
            </div>
            <div class="bottom-item" @click="jumpHz">
                <img src="../../assets/icon-hz.png" alt="">
                <div class="text">划转至御粮账户</div>
            </div>
        </div>
        <div class="bottom-links">
            <router-link to="/reward/rules" class="link-item">奖励政策</router-link>
        </div>
    </div>
</template>
<script>
import { Icon,Toast } from 'vant'

import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            pageData:{}
        }
    },
    components:{
        [Icon.name]:Icon,
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            url:config.api.chairmanAllowance
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        jumpApply(){
            this.$router.push({
                name:'withdraw-apply',
                params:{
                    amount:this.pageData.allowanceAmount
                }
            });
        },
        jumpHz(){
            this.$router.push({
                name:'huazhuan-apply',
                params:{
                    amount:this.pageData.allowanceAmount
                }
            });
        },
        jumpBill(){
            this.$router.push({
                name:'allowance-bill',
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    .page-top{
        padding:25px 20px;
        background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
        color:#fff;
        margin-bottom: 10px;
        .total{
            .total-box{
                .total-num{
                    @include flex-between();
                    font-size: 30px;
                    line-height: 35px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    font-weight: bold;
                    margin-bottom: 5px;
                    .see-bill{
                        position: relative;
                        right:-20px;
                        background: #fff;
                        font-size: 12px;
                        color:#3088F5;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        height:26px;
                        padding:0 12px;
                        border-top-left-radius: 14px;
                        border-bottom-left-radius: 14px;
                    }
                }
                .total-text{
                    font-size: 13px;
                    line-height: 18px;
                }
            }
        }
        .detail{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .detail-item{
                width:50%;
                .item-num{
                    font-weight: bold;
                    line-height: 21px;
                    font-family: DINAlternate-Bold, DINAlternate;
                    margin-bottom: 5px;
                }
                .item-text{
                    line-height: 18px;
                    font-size: 13px;
                }
            }
        }
    }
    .page-bottom{
        background:#fff;
        padding:20px 0;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .bottom-item{
            width:50%;
            text-align: center;
            box-sizing: border-box;
            &:first-child{
                border-right: 1px solid #f0f0f0;
            }
            &>img{
                width:50px;
                height:50px;
                margin-bottom: 12px;
            }
            .text{
                font-size: 16px;
                color:#333;
            }
        }
    }
    .bottom-links{
        width:100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        text-align: center;
        padding-bottom: 10px;
        .link-item{
            font-size: 14px;
            color:#3088F5;
            line-height: 20px;
        }
    }
}
</style>